import React, { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import './WhackAMole.css';

const WhackAMole = () => {
  const [moles, setMoles] = useState(Array(9).fill(false));
  const [score, setScore] = useState(0);
  const [timeLeft, setTimeLeft] = useState(30);
  const [gameActive, setGameActive] = useState(false);
  const [gameOver, setGameOver] = useState(false);

  const popUpMole = useCallback(() => {
    if (!gameActive) return;
    
    const randomIndex = Math.floor(Math.random() * 9);
    setMoles(prev => {
      const newMoles = [...prev];
      newMoles[randomIndex] = true;
      return newMoles;
    });

    // Hide mole after 1 second
    setTimeout(() => {
      setMoles(prev => {
        const newMoles = [...prev];
        newMoles[randomIndex] = false;
        return newMoles;
      });
    }, 1000);
  }, [gameActive]);

  const startGame = () => {
    setGameActive(true);
    setGameOver(false);
    setScore(0);
    setTimeLeft(30);
    setMoles(Array(9).fill(false));
  };

  const whackMole = (index) => {
    if (!gameActive || !moles[index]) return;
    
    setScore(prev => prev + 1);
    setMoles(prev => {
      const newMoles = [...prev];
      newMoles[index] = false;
      return newMoles;
    });
  };

  useEffect(() => {
    let timer;
    if (gameActive && timeLeft > 0) {
      timer = setTimeout(() => {
        setTimeLeft(prev => prev - 1);
      }, 1000);
    } else if (timeLeft === 0 && gameActive) {
      setGameActive(false);
      setGameOver(true);
    }
    
    return () => clearTimeout(timer);
  }, [timeLeft, gameActive]);

  useEffect(() => {
    let moleTimer;
    if (gameActive) {
      moleTimer = setInterval(() => {
        popUpMole();
      }, 800);
    }
    
    return () => clearInterval(moleTimer);
  }, [gameActive, popUpMole]);

  return (
    <div className="game-container">
      <div className="game-header">
        <h1 className="game-title-header">🔨 Whack-a-Mole</h1>
        <div className="game-instructions">
          Click on the moles as they pop up! Be quick - they don't stay up for long!
        </div>
      </div>

      <div className="game-board">
        <div className="score-display">
          Score: {score} | Time: {timeLeft}s
        </div>
        
        {!gameActive && !gameOver && (
          <div className="start-screen">
            <p>Ready to whack some moles?</p>
            <button className="btn btn-success" onClick={startGame}>
              Start Game
            </button>
          </div>
        )}

        {(gameActive || gameOver) && (
          <div className="game-play-area">
            <div className="mole-grid">
              {moles.map((isMoleUp, index) => (
                <div
                  key={index}
                  className={`mole-hole ${isMoleUp ? 'mole-up' : ''}`}
                  onClick={() => whackMole(index)}
                >
                  <div className="hole"></div>
                  {isMoleUp && <div className="mole">🐹</div>}
                </div>
              ))}
            </div>
          </div>
        )}

        {gameOver && (
          <div className="game-over">
            <h2>🎉 Game Over!</h2>
            <div className="final-score">
              <p>Final Score: {score} moles whacked!</p>
              <p>
                {score >= 20 ? '🏆 Mole Master!' : 
                 score >= 15 ? '👍 Great job!' : 
                 score >= 10 ? '👌 Not bad!' : '💪 Keep practicing!'}
              </p>
            </div>
          </div>
        )}

        <div className="game-controls">
          <button className="btn btn-primary" onClick={startGame}>
            {gameOver ? 'Play Again' : 'New Game'}
          </button>
          <Link to="/" className="btn btn-secondary">
            Back to Home
          </Link>
        </div>
      </div>
    </div>
  );
};

export default WhackAMole;